export default __webpack_public_path__ + "static/media/checkLightBlue.67d29338.svg";